import React from "react";
import PropTypes from "prop-types";
import { FavoritesIcon } from "../components";
import { Link } from "react-router-dom";

const PrayerAndRitesCard = ({
  id,
  slug,
  title,
  excerpt,
  favorite,
  catList,
  imageUrl,
  onToggleFavorite,
}) => {
  return (
    <Link to={"/prayer-and-rites/" + slug}>
      <div className="flex flex-row">
        <div className="w-[80px]">
          <img
            src={imageUrl}
            alt={title}
            className="block h-full bg-gray-200 max-h-98 max-w-20 rounded-bl-xl rounded-tl-xl w-[64px]"
          />
        </div>
        <div className="flex flex-col w-full px-4 py-3 bg-gold-50 rounded-br-xl rounded-tr-xl">
          <p className="text-base font-semibold leading-5 text-left text-gray-900 cursor-pointer">
            {title}
          </p>
          <span className="mt-1 text-xs font-normal leading-4 text-left text-gray-600">
            {excerpt ? excerpt.slice(0, 40) : ""}
          </span>
          <div className="flex justify-between">
            {Array.isArray(catList) && catList.filter(Boolean).length > 0 && (
              <div className="flex gap-2 mt-2.5">
                {catList.filter(Boolean).map((category, index) => (
                  <span
                    key={index}
                    className="px-2 py-1 text-xs font-medium leading-4 bg-white-50 text-gold-500 rounded-27"
                  >
                    {category}
                  </span>
                ))}
              </div>
            )}

            <button
              type="button"
              onClick={(e) => {
                e.preventDefault(); // Prevent page reload
                onToggleFavorite(id, e); // Call function passed as prop
              }}
              className="flex items-center focus:outline-none"
              aria-label={
                favorite ? "Remove from favorites" : "Add to favorites"
              }
            >
              <FavoritesIcon
                filled={favorite}
                className={`h-6 w-6 transition-colors duration-200 ${
                  favorite ? "text-red-100" : "text-gray-500 hover:text-red-100"
                }`}
              />
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
};

// Prop validation
PrayerAndRitesCard.propTypes = {
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string,
  favorite: PropTypes.bool.isRequired,
  catList: PropTypes.arrayOf(PropTypes.string).isRequired,
  imageUrl: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};

export default PrayerAndRitesCard;
